import {
  required,
  confirmed,
  email,
  min_value,
  max_value,
  max,
} from "vee-validate/dist/rules";
import { extend } from "vee-validate";
import i18n from "@/plugins/vue-i18n";
import axios from "axios";

extend("required", {
  ...required,
  message: i18n.t("form.msgFieldRequired"),
});

extend("email", {
  ...email,
  message: i18n.t("form.msgValidEmail"),
});

extend("confirmed", {
  ...confirmed,
  message: i18n.t("form.msgConfirmation"),
});

extend("min_value", {
  ...min_value,
  message: (_, { min }) => i18n.t("form.msgMinValue", { value: min }),
});

extend("max_value", {
  ...max_value,
  message: (_, { max }) => i18n.t("form.msgMaxValue", { value: max }),
});

extend("max_length", {
  ...max,
  message: (_, { length }) => i18n.t("form.msgMaxLength", { value: length }),
});

extend("is_valid", {
  message: i18n.t("form.msgConfirmationDataListValidation"),
  validate: async (value, args) => {
    // Vee validate Backend Validation http://vee-validate.logaretm.com/v2/concepts/backend.html
    // Le seul et unique arg doit être l'url à appeller pour valider la valeur

    let isValid = false;
    if (args.length == 1) {
      try {
        const url = `${args[0]}?text=${value}`;
        var result = await axios.get(url);
        isValid = result.status === 204;
      } catch (error) {
        isValid = false;
      }
    }
    return {
      valid: isValid,
    };
  },
});

extend("required_email_not_exist", {
  message: i18n.t("form.msgEmailExist"),
  validate: async (value, args) => {
    // Vee validate Backend Validation http://vee-validate.logaretm.com/v2/concepts/backend.html
    // Le seul et unique arg doit être l'url à appeller pour vérifier l'email

    if (args.length == 1) {
      try {
        const url = `${args[0]}/${value}`;
        await axios.get(url);

        return {
          valid: true,
        };
      } catch (error) {
        const valid = error.response.status === 404;

        return {
          valid,
        };
      }
    }
  },
});

extend("password", {
  message: i18n.t("form.msgFieldPassword"),
  validate: async (value, args) => {
    // Vee validate Backend Validation http://vee-validate.logaretm.com/v2/concepts/backend.html
    // Le seul et unique arg doit être l'url à appeller pour vérifier l'email

    let isValid = false;

    if (args.length == 1) {
      try {
        const url = args[0];
        const data = new URLSearchParams();
        data.append("password", value);

        var result = await axios.post(url, data, {
          headers: {
            "content-type": "application/x-www-form-urlencoded",
          },
        });
        isValid = result.status === 200;
      } catch (error) {
        isValid = false;
      }
    }
    return {
      valid: isValid,
    };
  },
});

// extend("max_length");
